import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Download, Key, Mail } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-[#0C2818] border-y border-[#1E4D2B]" data-id="element-158">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        {/* Guarantee Box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#143524] rounded-3xl p-8 md:p-12 border-2 border-[#16A34A] text-center mb-16 relative overflow-hidden" data-id="element-160">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_top,#16A34A_0%,transparent_50%)] opacity-10 pointer-events-none" data-id="element-161"></div>

          <div className="w-20 h-20 bg-[#16A34A] rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(22,163,74,0.4)]" data-id="element-162">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-163" />
          </div>

          <h2 className="text-3xl font-black text-white mb-6" data-id="element-164">
            Garantía MEGAPACK LISTO PARA IMPRIMIR — 30 días
          </h2>

          <p className="text-lg text-gray-300 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-165">
            Podés revisar todo el material tranquilamente. Abrir las guías.
            Explorar las actividades. Probar algunas dinámicas con tus alumnos.
          </p>

          <p className="text-lg text-gray-300 mb-6" data-id="element-166">
            Si dentro de 30 días sentís que el material no te ayuda a mejorar
            tus clases:
          </p>

          <p className="text-2xl font-bold text-[#FBBF24] mb-8" data-id="element-167">
            Te devolvemos el 100% de tu dinero.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 text-white font-medium" data-id="element-168">
            <span className="flex items-center gap-2" data-id="element-169">
              <div className="w-2 h-2 rounded-full bg-[#16A34A]" data-id="element-170"></div>
              Sin preguntas
            </span>
            <span className="flex items-center gap-2" data-id="element-171">
              <div className="w-2 h-2 rounded-full bg-[#16A34A]" data-id="element-172"></div>
              Sin trámites complicados
            </span>
            <span className="flex items-center gap-2" data-id="element-173">
              <div className="w-2 h-2 rounded-full bg-[#16A34A]" data-id="element-174"></div>
              Sin condiciones ocultas.
            </span>
          </div>
        </motion.div>

        {/* Security Features */}
        <div className="text-center" data-id="element-175">
          <h3 className="text-2xl font-bold text-white mb-10" data-id="element-176">
            Compra 100% segura
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-12" data-id="element-177">
            {[{
            icon: Lock,
            text: 'Pago protegido por plataforma segura'
          }, {
            icon: ShieldCheck,
            text: 'Protección completa de tus datos personales'
          }, {
            icon: Download,
            text: 'Descarga inmediata del material'
          }, {
            icon: Key,
            text: 'Acceso privado al contenido'
          }, {
            icon: Mail,
            text: 'Soporte por email si necesitás ayuda'
          }].map((item, i) => <div key={i} className="flex flex-col items-center gap-3 p-4" data-id="element-178">
                <item.icon className="w-8 h-8 text-[#16A34A]" data-id="element-179" />
                <span className="text-gray-300 text-sm font-medium" data-id="element-180">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-[#FBBF24] font-bold text-lg uppercase tracking-wider" data-id="element-181">
            Miles de docentes ya lo están usando.
          </p>
        </div>
      </div>
    </section>;
}